import styled from "styled-components";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { LoadingBackDrop } from "../../../components/loader";
import { styled as _styled } from "@mui/material/styles";
import { theme } from "../../../helpers/theme";

import { getAllWarehouses } from "../../../services/warehouses/get-all";
import { GetAllWarehouses } from "../../../services/warehouses/get-all/types";
import SessionService from "../../../services/session-service";
import { getLoggedUsersData } from "../../../services/users/get-logged";
import SubcontractorTable from "./subcontractor-table";

import { GetByLoggedSubcontractorWarehouses } from "../../../services/warehouses/get-by-logged-subcontractor/types";
import { getByLoggedSubcontractor } from "../../../services/warehouses/get-by-logged-subcontractor";

const SubcontractorSubcontractors = () => {
  const [subcontractorId, setSubcontractorId] = useState<string>("");
  const [subcontractorWarehouses, setSubcontractorWarehouses] = useState<
    GetByLoggedSubcontractorWarehouses[]
  >([]);

  const body = {
    paginacja: null,
  };
  const GetByLoggedSubcontractor = useQuery(
    ["ByLoggedSubcontractor"],
    () => getByLoggedSubcontractor(body),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      onSuccess(data) {
        setSubcontractorWarehouses(data.data.payload.magazyny);
      },
    }
  );
  // const GetAllWarehouses = useQuery(
  //   ["warehouses"],
  //   () => getAllWarehouses(body),
  //   {
  //     refetchOnMount: true,
  //     refetchOnWindowFocus: false,
  //     onSuccess(data) {
  //       setWarehouses(data.data.payload.magazyny);
  //     },
  //   }
  // );
  const GetLoggedData = useQuery(
    ["LoggedUsersData"],
    () => getLoggedUsersData(),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        SessionService.setLoggedUserData(data.data.payload.dane_wykonawca);
        setSubcontractorId(data.data.payload.dane_wykonawca.id_wykonawca);
      },
    }
  );

  // const subcontractorWarehouse = warehouses.filter(
  //   (warehouse) =>
  //     warehouse.wykonawcy.length > 0 &&
  //     warehouse.wykonawcy[0].id_wykonawcy.toString() === subcontractorId
  // );
  if (
    GetByLoggedSubcontractor.isLoading ||
    GetByLoggedSubcontractor.isRefetching
  ) {
    return <LoadingBackDrop loading={true} />;
  }

  return (
    <>
      {subcontractorWarehouses.length > 0 ? (
        <SubcontractorTable subcontractorWarehouse={subcontractorWarehouses} />
      ) : (
        <NoWarehousesInfo>
          {subcontractorWarehouses === undefined
            ? null
            : `Brak przypisanych magazynów`}
        </NoWarehousesInfo>
      )}
    </>
  );
};

export default SubcontractorSubcontractors;

const NoWarehousesInfo = styled.span`
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 20px;
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 30px;
`;
